import { useAuthentication } from '../contexts/AuthContext';
import LabDeploymentService from '../services/LabDeploymentService';
import { IGetAllLabDeployments } from '../services/LabDeploymentService/types';
import { useCallbackWithLoading } from './useCallbackWithLoading';

interface IUseVDPReport {
  startLab: (payload: {
    eventId: string;
    challengeId: string;
  }, sessionToken?: string) => Promise<any>;
  userDeleteLab: (payload: {
    workspace: string;
  }, sessionToken?: string) => Promise<any>;
  adminDeleteLab: (payload: {
    workspace: string;
    labId: string;
  }, sessionToken?: string) => Promise<any>;
  getAllLabDeployments:(queryParams: {
    page: number;
    limit: number;
    eventId?: string;
    userId?: string;
    status?: string;
}, sessionToken?: string) => Promise<IGetAllLabDeployments>;
}

export const useLabDeployment = (): IUseVDPReport => {
  const { sessionToken } = useAuthentication();

  const startLab = useCallbackWithLoading(async (payload: { eventId: string, challengeId?: string}) => {
    const solutionResponse = await LabDeploymentService.startLab(
      payload, sessionToken?.rawValue,
    );
    return solutionResponse;
  }, [sessionToken?.rawValue]);

  const userDeleteLab = useCallbackWithLoading(async (payload: { workspace: string }) => {
    const solutionResponse = await LabDeploymentService.userDeleteLab(
      payload, sessionToken?.rawValue,
    );
    return solutionResponse;
  }, [sessionToken?.rawValue]);

  const adminDeleteLab = useCallbackWithLoading(async (payload: { workspace: string, labId: string }) => {
    const solutionResponse = await LabDeploymentService.adminDeleteLab(
      payload, sessionToken?.rawValue,
    );
    return solutionResponse;
  }, [sessionToken?.rawValue]);

  const getAllLabDeployments = useCallbackWithLoading(async (
    params: {page: number, limit: number, eventId?: string, userId?: string, status?: string},
  ) => {
    const allVDPReports = await LabDeploymentService.getAllLabDeployments(
      params, sessionToken?.rawValue,
    );
    return allVDPReports;
  }, [sessionToken?.rawValue]);

  return {
    getAllLabDeployments,
    startLab,
    userDeleteLab,
    adminDeleteLab,
  };
};
